import { Recepciones_definitivas } from '../../../models/recepciones_definitivas.model';
import { Component, ViewChild, ElementRef, TemplateRef } from "@angular/core";
import * as moment from 'moment'
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { FormService } from 'src/app/services/form.service';
import { MatDialog } from '@angular/material';
declare var jQuery: any;
declare var $: any;
@Component({
  selector: 'app-recepciones-definitivas',
  templateUrl: './recepciones-definitivas.component.html',
  styleUrls: ['./recepciones-definitivas.component.css'],
  providers: [FormService]
})
export class RecepcionesDefinitivasComponent  {
  @ViewChild('openModal') openModal: TemplateRef<any>;
  @ViewChild('openModalNODATA') openModalNODATA: TemplateRef<any>;

  public rows = [];
  public actualRow;
  public recepciones_definitivas: Recepciones_definitivas;
  public form;
  public temp_perm;
  public matcher = new FormService();
  public maxDate;
  public selected;

  constructor(private fb: FormBuilder, private dialog: MatDialog) {
      this.maxDate = moment().toDate()

      this.form = new FormGroup({
        tipo_recepcion: new FormControl(''),
          numero_recepcion: new FormControl(''),
          fecha_recepcion: new FormControl(''),

      })


      if (!JSON.parse(localStorage.getItem("recepciones_definitivas"))) {
          localStorage.setItem("recepciones_definitivas", JSON.stringify(this.rows));
      } else {
          this.rows = JSON.parse(localStorage.getItem("recepciones_definitivas"));

      }
      this.recepciones_definitivas = { tipo_recepcion: '', numero_recepcion: '', fecha_recepcion: '' };
      this.temp_perm = { tipo_recepcion: '', numero_recepcion: '', fecha_recepcion: '' };

  }

  add_permisos_recepciones() {

      this.actualRow = localStorage.getItem("recepciones_definitivas");
      this.rows = JSON.parse(this.actualRow);

      /*     console.log(this.form.value); */

      if (!this.form.value.tipo_recepcion || !this.form.value.numero_recepcion || !this.form.value.fecha_recepcion) {
          console.log("no se ingresaron datos");
          this.dialog.open(this.openModalNODATA);
      } else {
          this.rows = this.rows.concat({
              tipo_recepcion: this.form.value.tipo_recepcion,
              numero_recepcion: this.form.value.numero_recepcion,
              fecha_recepcion: this.form.value.fecha_recepcion ? moment(this.form.value.fecha_recepcion).format('DD/MM/YYYY') : "", 

          })
          localStorage.setItem("recepciones_definitivas", JSON.stringify(this.rows));
          this.form.reset();
      }
  }
  delete_permisos_recepciones(id) {
      for (let x = 0; x < this.rows.length; x++) {
          if (id == x) {
              this.rows.splice(x, 1);
              localStorage.setItem("recepciones_definitivas", JSON.stringify(this.rows));
          }
      }
  }

  onChangeSelect(event) {
      let value = event.target.value;
  }
  get_permisos_recepciones(id) {
      for (let x = 0; x < this.rows.length; x++) {

          if (id == x) {
              this.temp_perm.id = id;
              this.temp_perm.tipo_recepcion = this.rows[x].tipo_recepcion;
              this.temp_perm.numero_recepcion = this.rows[x].numero_recepcion;
              this.temp_perm.fecha_recepcion = this.rows[x].fecha_recepcion;

              this.dialog.open(this.openModal);

          }
      }
  }

  cleanData() {
      this.temp_perm = { tipo_recepcion: '', numero_recepcion: '', fecha_recepcion: '' };

  }

  savepermisos_recepciones() {
      var id = this.temp_perm.id;
      for (let x = 0; x < this.rows.length; x++) {
          if (id == x) {
              this.rows.splice(x, 1);
              localStorage.setItem("recepciones_definitivas", JSON.stringify(this.rows));

              $("#antec_modal").modal("hide");
              this.actualRow = localStorage.getItem("recepciones_definitivas");
              this.rows = JSON.parse(this.actualRow);
              this.rows = this.rows.concat({
                  tipo_recepcion: this.temp_perm.tipo_recepcion,
                  numero_recepcion: this.temp_perm.numero_recepcion,
                  fecha_recepcion: this.temp_perm.fecha_recepcion,

              })
              localStorage.setItem("recepciones_definitivas", JSON.stringify(this.rows));
              //this.temp_perm.reset();
              this.dialog.closeAll();
          }
      }
  }

}
